import React, { useState, useEffect, useCallback } from "react";
// Styles
import { useTheme } from "@fluentui/react";
import { getChecklistProgressBarConfettiClassNames } from "./ChecklistProgressBarConfetti.styles";
/** Component which shows a confetti animation when the last checklist item is completed */ export const ChecklistProgressBarConfetti = ({ styles, isLastChecklistItemMarkedComplete: isLastChecklistItemMarkedCompleteFromProps })=>{
    // Duration of the complete animation in ms
    const COMPLETE_ANIMATION_DURATION = 1200;
    // Duration of the uncomplete animation in ms
    const UNCOMPLETE_ANIMATION_DURATION = 100;
    /** Flag to show confetti animation*/ const [isLastChecklistitemMarkedComplete, setIsLastChecklistitemMarkedComplete] = useState(isLastChecklistItemMarkedCompleteFromProps);
    /** Flag to set to start confetti animation or not  */ const [animate, setAnimate] = useState(false);
    /** Current theme of the app */ const theme = useTheme();
    /** Classnames associated with the computed styles */ const classNames = getChecklistProgressBarConfettiClassNames(theme, isLastChecklistitemMarkedComplete, animate, styles);
    /**
     * Callback to play the css animation
     */ const playCssAnimation = useCallback(()=>{
        const timeoutDuration = isLastChecklistitemMarkedComplete ? UNCOMPLETE_ANIMATION_DURATION : COMPLETE_ANIMATION_DURATION;
        setTimeout(()=>{
            setAnimate(true);
        }, COMPLETE_ANIMATION_DURATION);
        setIsLastChecklistitemMarkedComplete((prevState)=>!prevState);
        setTimeout(()=>{
            setAnimate(false);
        }, timeoutDuration); // set a time delay thus animation can be visible
    }, [
        isLastChecklistitemMarkedComplete
    ]);
    /** Method called after either of the dependencies update */ useEffect(()=>{
        if (isLastChecklistItemMarkedCompleteFromProps !== isLastChecklistitemMarkedComplete) {
            playCssAnimation();
        }
    }, [
        isLastChecklistItemMarkedCompleteFromProps,
        isLastChecklistitemMarkedComplete,
        playCssAnimation
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    });
};
